import * as React from "react";

const CounterContext = React.createContext();

const CounterProvider = ({ children, ...props }) => {
  const [state, setState] = React.useState("");
  return (
    <CounterContext.Provider value={[state, setState]} {...props}>
      {children}
    </CounterContext.Provider>
  );
};

export default CounterProvider;

export const useCounterId = () => {
  const context = React.useContext(CounterContext);
  if (context === undefined) {
    throw new Error(`useCounterId must be used within a CounterProvider`);
  }
  return context;
};
